import RewardsPage from './RewardsPage';
import RewardsToolbar from './RewardsToolbar';

export default {
  RewardsPage,
  RewardsToolbar,
};
